import React from "react";
import { cn } from "@/components/utils/utils";
import { DashboardTravelRequest } from "@/lib/models/dashboard";
import { useI18n } from '@/hooks/useI18n';
import { useAuth } from '@/hooks/useAuth';

interface TravelRequestBadgeProps {
  travelRequest: DashboardTravelRequest;
  className?: string;
}

export const TravelRequestBadge: React.FC<TravelRequestBadgeProps> = ({
  travelRequest,
  className,
}) => {
  const { t } = useI18n();
  const { userRole } = useAuth();
  // "Assegnata" non c'e' piu': lo dice gia' la pillola In corso. Resta solo "Da
  // assegnare", che chiede un'azione -- e quindi non al cliente, che non la puo' fare.
  const showToAssign = userRole !== 'traveler' && travelRequest.needsAssignment;
  
  // Funzione per verificare se la richiesta è nuova (creata negli ultimi 24 ore)
  const isNewRequest = () => {
    const createdAt = new Date(travelRequest.createdAt);
    const now = new Date();
    const diffInHours = (now.getTime() - createdAt.getTime()) / (1000 * 60 * 60);
    return diffInHours <= 24;
  };

  // Funzione per ottenere il testo del badge status
  const getStatusBadgeText = () => {
    switch (travelRequest.status) {
      case 'completed':
        return t('travelRequest.statusCompleted');
      case 'rejected':
        return t('travelRequest.statusRejected');
      default:
        return travelRequest.status;
    }
  };

  // Funzione per ottenere gli stili del badge status (allineato con ItineraryCard)
  const getStatusBadgeStyles = () => {
    switch (travelRequest.status) {
      case 'completed':
        return 'bg-green-100 border border-green-300 text-green-800';
      case 'rejected':
        return 'bg-red-100 border border-red-300 text-red-800';
      default:
        return 'bg-gray-100 border border-gray-300 text-gray-800';
    }
  };


  return (
    <div className="flex flex-wrap gap-1 items-start">
      {showToAssign && (
        <div className={cn(
          "shrink-0 whitespace-nowrap px-3 py-1 rounded-full shadow-sm flex items-center gap-2",
          "bg-amber-100 border border-amber-300 text-amber-800",
          className
        )}>
          <span className="text-xs">
            {t('travelRequest.statusToAssign')}
          </span>
        </div>
      )}
      {(travelRequest.status === 'completed' || travelRequest.status === 'rejected') && (
        <div className={cn(
          "shrink-0 whitespace-nowrap px-3 py-1 rounded-full shadow-sm flex items-center gap-2",
          getStatusBadgeStyles(),
          className
        )}>
          <span className="text-xs">
            {getStatusBadgeText()}
          </span>
        </div>
      )}
      {isNewRequest() && (
        <div className={cn(
          "shrink-0 whitespace-nowrap px-3 py-1 rounded-full shadow-sm flex items-center gap-2",
          "bg-blue-100 border border-blue-300 text-blue-800",
          className
        )}>
          <span className="text-xs">
            {t('travelRequest.statusNew')}
          </span>
        </div>
      )}
    </div>
  );
};
